<template>
  <div id="container">
    <div class="top-container">
      <div class="content-box">
        <div style="text-align:center;">
          <div>
            <img id="ci-image" :src="CI_HORIZONTAL" />
          </div>
          <div class="guide-text">
           <span >서비스 이용을 위해 로그인 해주세요.</span>
          </div>
        </div>
        <form class="form-box" v-if="!show2FA">
          <label for="id" class="label">ID</label>
          <input id="id" type="text" v-model="email" class="form-control" placeholder="ID" />
          <label for="password" class="label">PASSWORD</label>
          <div class="password-box" @keydown.enter="sign">
            <input :type="inputType" v-model="password" class="form-control" placeholder="PASSWORD"/>
            <BIconEye id="eye" v-if="isVisible" @click="setVisible"/>
            <BIconEyeSlash id="eye" v-if="!isVisible" @click="setVisible"/>
          </div>
          <div class="reset-btn-div"><button type="button" class="reset-btn" @click="resetBtn">비밀번호 초기화</button></div>
          <button type="button" @click="sign" class="btn btn-primary" :style="{ backgroundColor: SKY_BLUE, color: '#ffffff'}">
            로그인
          </button>
        </form>
        <form class="form-box" v-if="show2FA">
          <label for="id" class="label">문자 코드 확인</label>
          <div class="position-relative">
            <input id="id" type="text" v-model="verificationCode" class="form-control" placeholder="" />
            <div class="veri-code-timer">{{veriCodeTimer}}</div>
          </div>
          <div class="text-body-2">
            <div class="mt-2">*제한시간 이내에 인증코드를 입력하셔야 합니다.</div>
            <div class="mt-1">
              3분 이내 SMS 수신이 되지 않은 경우, <span class="fake-link" @click="resendVerificationCode">여기를 눌러 다시 수신</span> 할 수 있습니다.
            </div>
          </div>
          <button type="button" @click="sign" class="btn btn-primary mt-2" :style="{ backgroundColor: SKY_BLUE, color: '#ffffff'}">
            로그인
          </button>
        </form>
      </div>
      <img alt="kona taxi" :src="CAR_IMG" id="taxi"/>
    </div>
    <div class="bottom-container" >
      <img id="bottom-img" alt="gray box" :src="BOTTOM_IMG"/>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from "vue";
import { useStore } from "vuex";
import axios from "@/composables/Axios";
import { CI_HORIZONTAL, BOTTOM_IMG, CAR_IMG } from "@/asset";
import { SKY_BLUE } from "@/styles/colors";
import {BIconEye, BIconEyeSlash} from "bootstrap-icons-vue";
import router from "@/router"
import dayjs from "dayjs";
import {isTachowOutdated} from "@/components/version-checker/version-checker-utils";

const store = useStore(),
      show2FA = ref(false),
      url = store.state.api.autoUrl,
      setSignIn = () => store.commit("sign/setSignIn"),
      setUserInfo = (value) => store.commit("sign/setUserInfo", value),
      setToken = (value) => store.commit("sign/setToken", value),
      setRefreshToken = (value) => store.commit("sign/setRefreshToken", value),
      setMenuPermission = (value) => store.commit("sign/setMenuPermission", value),
      setLoading = (value) => store.commit("setLoading", value),
      setInitContent = () => store.commit('content/setInitContent');

// const email = ref("admin@admin.com");
// const password = ref("admin");
const email = ref("");
const password = ref("");
const verificationCode = ref("");
const veriCodeTimer = ref("");
const veriCodeExpireAt = ref(null);

const isVisible = ref(false);
const inputType = ref("password");

const resetBtn = () => {router.push('sign/reset');}

const resendVerificationCode = async () => {
  verificationCode.value = "";
  show2FA.value = false;
  sign();
}

const updateVeriCodeTimer = () => {
  const now = dayjs();
  const secondDiff = veriCodeExpireAt.value.diff(now, "seconds");
  const seconds = secondDiff % 60;
  const min = Math.floor(secondDiff / 60);
  veriCodeTimer.value = `${min < 10 ? "0" + min : min}:${seconds < 10 ? "0" + seconds : seconds}`;
};

const tickTimer = () => {
  const now = dayjs();
  if (now.isAfter(veriCodeExpireAt.value)) {
    show2FA.value = false;
    return;
  }

  updateVeriCodeTimer();
  setTimeout(tickTimer, 1000);
};

const startTimer = () => {
  show2FA.value = true;
  veriCodeExpireAt.value = dayjs().add(3, "minute");
  updateVeriCodeTimer();
  setTimeout(tickTimer, 1000);
};


const sign = async () => {
  setLoading(true);

  try{
    const body = {
      email: email.value,
      password: password.value,
    };

    if (show2FA.value) {
      body.smsAuthCode = verificationCode.value;
    }

    const res = await axios.$post(url + "login", body);

    if (!res.data.access_token && !show2FA.value) {
      setLoading(false);
      startTimer();
      return;
    }

    setUserInfo(res.data.data.user);
    setToken(res.data.access_token);
    setRefreshToken(res.data.refresh_token);

    setMenuPermission(res.data.data.menuList)
    setInitContent();

    if(res.data.data.user.initPassword === 'Y'){
      await router.push('sign/change');
    }else{
      setSignIn();
    }
  } catch(error) {
    if(confirm(error.response.data.message)){
      if(error.response.data.code === '1001_0000_004'){
        await router.push('sign/reset');
      }
    }
    // store.commit('openMessageBox', error.response.data.message);
    // alert(error.response.data.message);

  } finally {
    setLoading(false);
  }
};

const setVisible = () => {
  isVisible.value = !isVisible.value
  inputType.value = isVisible.value ? "text" : "password"
}

onMounted(async () => {
  if (await isTachowOutdated(store)) {
    store.commit('openMessageBox', '');
  }
})

</script>

<style scoped>
.fake-link {
  color: #0a53be;
  margin: 0;
}

.veri-code-timer {
  position: absolute;
  right: 10px;
  top: 8px;
  pointer-events: none;
  color: #d62d2d;
}

#container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.top-container {
  position: relative;
  display:flex;
  justify-content: space-around;
  width: 100%;
  height: 60rem;
}
.content-box {
  width: 23rem;
  margin: auto;
  z-index: 1;
}
#ci-image {
  width: 100%;
  margin:1rem 0;
}
.guide-text {
  font-size: 0.9rem;
  margin: 1.5rem 0 0rem;
}

.form-box {
  display: flex;
  flex-direction: column;
  /*width: 100%;*/
  margin-left: 0 !important;
}
.label {
  font-size: 0.8rem;
  margin: 1rem 0 0.5rem;
}
.password-box{
  position:relative;
}
#eye {
  position:absolute;
  top:0.7rem;
  right:1rem;
  cursor: pointer;
}
.row-box {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
}
#sign-in-text {
  cursor: pointer;
  margin: 0 1rem;
}
.bottom-container {
  width: 100%;
}
#taxi {
  width: 35%;
  min-width: 25rem;
  position: absolute;
  right:0;
  bottom:0;
}
#bottom-img{
  width:100%;
  min-height: 10rem;
}
.reset-btn-div{
  text-align: right;
  margin: 0.5rem 0;
}
.reset-btn-div .reset-btn{
  font-size: 12px;
}
.reset-btn{
  background-color: #ffffff;
}
</style>
